import { format, isToday, isTomorrow } from "date-fns";

/** Convert whatever Firestore/API sends (ISO string, Timestamp object, Date) to a JS Date */
export function toDate(value: unknown): Date {
  if (value instanceof Date) return value;
  // Firestore Timestamp serialised as { _seconds, _nanoseconds }
  if (value && typeof value === "object" && "_seconds" in (value as object)) {
    return new Date((value as { _seconds: number })._seconds * 1000);
  }
  // Firestore Timestamp serialised as { seconds, nanoseconds }
  if (value && typeof value === "object" && "seconds" in (value as object)) {
    return new Date((value as { seconds: number }).seconds * 1000);
  }
  return new Date(value as string);
}

export function formatEventDate(dateStr: unknown): string {
  try {
    const d = toDate(dateStr);
    if (isNaN(d.getTime())) return "";
    if (isToday(d)) return `Today ${format(d, "h:mm a")}`;
    if (isTomorrow(d)) return `Tomorrow ${format(d, "h:mm a")}`;
    return format(d, "EEE, MMM d · h:mm a");
  } catch {
    return "";
  }
}

export function formatShortDate(dateStr: unknown): string {
  try {
    const d = toDate(dateStr);
    if (isNaN(d.getTime())) return "";
    return format(d, "MMM d, yyyy");
  } catch {
    return "";
  }
}
